import { Button, Popconfirm, Tag } from 'antd';
import type { TrailerView } from './trailers.api';

interface TrailerStatusControlProps {
  trailer: Pick<TrailerView, 'registration' | 'isActive'>;
  canManage: boolean;
  onActivate: () => Promise<void>;
  onDeactivate: () => Promise<void>;
}

/** Deactivating a trailer affects dispatch eligibility elsewhere, so it asks first — same weight CLAUDE.md gives closing out a trip. */
export function TrailerStatusControl({ trailer, canManage, onActivate, onDeactivate }: TrailerStatusControlProps) {
  if (!canManage) return <Tag color={trailer.isActive ? 'success' : 'default'}>{trailer.isActive ? 'Active' : 'Inactive'}</Tag>;

  if (trailer.isActive) {
    return (
      <Popconfirm title={`Deactivate ${trailer.registration}?`} description="Review open trips for this trailer first." onConfirm={onDeactivate}>
        <Button danger>Deactivate</Button>
      </Popconfirm>
    );
  }

  return (
    <Popconfirm title={`Reactivate ${trailer.registration}?`} onConfirm={onActivate}>
      <Button>Activate</Button>
    </Popconfirm>
  );
}
